import { useState } from "react";

// Money input used across the project form grids.
// Supports the spreadsheet "Q|amount" habit: typing a leading "Q" (e.g.
// "Q5000") marks the month's amount as a QUERY/quoted figure — the number
// still counts in totals but renders with a Q badge so it's visibly soft.
// When `negativeDefault` is true (sub-consultants row), a bare number gets
// stored as its negation. Explicit "+" keeps it positive; "-" behaves as it
// always has. Existing stored values are untouched — this only affects the
// value produced from a *new* commit.
export default function MoneyCell({ value, flag, onChange, testid, allowFlag = true, negativeDefault = false }) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");
  const display = focused
    ? draft
    : (value
        ? (value < 0
            ? `${flag === "Q" ? "Q " : ""}−$${Math.abs(Number(value)).toLocaleString()}`
            : `${flag === "Q" ? "Q " : ""}$${Number(value).toLocaleString()}`)
        : "");
  return (
    <input
      type="text"
      inputMode="decimal"
      value={display}
      onFocus={(e) => {
        setDraft(value ? `${flag === "Q" ? "Q" : ""}${value}` : "");
        setFocused(true);
        setTimeout(() => e.target.select(), 0);
      }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => {
        const raw = String(draft).trim();
        const isQ = allowFlag && /^q/i.test(raw);
        // Sign detection BEFORE stripping — a bare number in a negativeDefault
        // cell becomes negative unless explicitly plus-prefixed.
        const body = raw.replace(/^q/i, "").trim();
        const hasPlus  = /^\+/.test(body);
        const hasMinus = /^-/.test(body);
        const magnitude = Number(body.replace(/[^0-9.]/g, "")) || 0;
        let cleaned;
        if (hasMinus)      cleaned = -magnitude;
        else if (hasPlus)  cleaned =  magnitude;
        else               cleaned = negativeDefault ? -magnitude : magnitude;
        onChange(cleaned, isQ && cleaned ? "Q" : null);
        setFocused(false);
      }}
      placeholder="—"
      className={`w-full px-2 py-2 bg-transparent font-mono-num text-xs text-right outline-none border-0 focus:bg-white hover:bg-[var(--paper-soft)]/40 placeholder:text-[var(--rule-strong)] ${flag === "Q" && !focused ? "text-[#8a6d1a] italic" : ""}`}
      data-testid={testid}
      title={flag === "Q" ? "Query amount — prefix with Q to mark as unconfirmed" : (negativeDefault ? "Sub-consultants row — bare numbers store as negative. Prefix with + to force positive." : undefined)}
    />
  );
}
